var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamilia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FAE506;}\n\t.st1{fill:#2F2C26;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.7,13.8c0.7-0.5,1.2-1.3,1.2-2.2c0-1.5-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7c0,0.9,0.5,1.7,1.2,2.2 c-0.2,0.1-0.5,0.2-0.7,0.3c-0.4-0.4-1-0.6-1.6-0.6c-0.3,0-0.6,0.1-0.9,0.2c-0.4-0.4-0.8-0.7-1.3-0.9c0.7-0.5,1.2-1.3,1.2-2.2 c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7c0,0.9,0.5,1.8,1.2,2.2c-1.5,0.6-2.6,2.2-2.6,3.9v2.3c0,0.7,0.6,1.3,1.3,1.3h4 c0,0,0,0,0.1,0s0,0,0.1,0h4.8c0,0,0,0,0.1,0s0,0,0.1,0h4c0.7,0,1.3-0.6,1.3-1.3v-1.4C20.3,16,19.2,14.4,17.7,13.8z M14.3,11.6 c0-1.1,0.9-1.9,1.9-1.9s1.9,0.9,1.9,1.9s-0.9,1.9-1.9,1.9S14.3,12.6,14.3,11.6z M14,15.7c0,0.8-0.7,1.5-1.5,1.5S11,16.6,11,15.7 c0-0.8,0.7-1.5,1.5-1.5S14,14.9,14,15.7z M6.8,10.6c0-1.1,0.9-1.9,1.9-1.9s1.9,0.9,1.9,1.9s-0.9,1.9-1.9,1.9S6.8,11.7,6.8,10.6z  M5.4,19.1v-2.3c0-1.8,1.4-3.4,3.2-3.5c0.9,0,1.7,0.3,2.3,0.8c-0.4,0.4-0.7,1-0.7,1.6c0,0.7,0.4,1.4,0.9,1.8 c-0.8,0.4-1.4,1.2-1.5,2.1H6C5.7,19.7,5.4,19.4,5.4,19.1z M12.5,18c1,0,1.9,0.7,2,1.7h-4.1C10.6,18.7,11.5,18,12.5,18z M19.6,19.1 c0,0.3-0.2,0.6-0.6,0.6h-3.7c-0.1-0.9-0.7-1.7-1.5-2.1c0.6-0.4,0.9-1.1,0.9-1.8c0-0.4-0.1-0.7-0.2-1c0.6-0.3,1.2-0.5,1.9-0.5 c1.8,0.1,3.2,1.7,3.2,3.5V19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.1,8.7c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2l1.4-1.4c0.6-0.6,0.7-1.4,0.2-2c0,0,0,0,0,0 c-0.3-0.4-0.6-0.6-1.1-0.7c-0.3-0.1-0.7,0-1,0.2c-0.3-0.2-0.7-0.2-1-0.2c-0.4,0.1-0.8,0.3-1.1,0.7c-0.4,0.6-0.3,1.5,0.2,2 L12.1,8.7z M11,5.7c0.1-0.2,0.3-0.3,0.6-0.4c0,0,0.1,0,0.1,0c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.3,0.1,0.5,0 c0.2-0.1,0.4-0.2,0.7-0.2c0.2,0,0.4,0.2,0.6,0.4c0.2,0.3,0.1,0.8-0.1,1.1l-1.3,1.3l-1.3-1.3C10.9,6.4,10.8,6,11,5.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilia);
export default __webpack_public_path__ + "static/media/familia.bab8cff14347e4d542ac888caba09738.svg";
export { ForwardRef as ReactComponent };